import React, { useState, useEffect, useContext } from 'react';
import Layout from './layout';
import Modal from '../../components/Modal';

import api from '../../services/api';
import AppContext from '../../redux/contexts/appContext';

function Boards() {

  const [boards, setBoards] = useState([]);
  const [loading, setLoading] = useState(false);
  const {state, dispatch} = useContext(AppContext);
  const [alertModal, setAlertModal] = useState(null);

  const getBoards = () => {
    setLoading(true);
    api().get(`/user/${state.user.id}/boards`)
    .then(response => {
      if (response.data.result) {
        setBoards(response.data.result);
      }
      setLoading(false);
    })
    .catch(err => {
      setLoading(false);
      if (err?.response?.data?.msg) {
        setAlertModal(err.response.data.msg);
      }
    })
  }

  useEffect(() => {
    if (state.user.token) {
      getBoards();
    }
  }, [state])

  return (
    <>
      <Layout boards={boards} loading={loading}></Layout>
      <Modal visible={alertModal !== null} title={"Alert"} onCancel={() => setAlertModal(null)} onSubmit={() => setAlertModal(null)} cancelText={false} >
        {alertModal}
      </Modal>
    </>
  );
}

export default Boards;